import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UsersUpdateData } from '../../../types/users'
import { useApiPostMutation } from '../useApi'

export const useUsersUpdate = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UsersUpdateData>()

  return {
    ...mutation,
    mutateAsync: async (data: UsersUpdateData) => {
      const result = await mutation.mutateAsync({
        url: '/users/update',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['usersList'] })
      queryClient.invalidateQueries({ queryKey: ['userDetail', data.ID] })
      return result
    },
    mutate: (data: UsersUpdateData) => {
      mutation.mutate(
        {
          url: '/users/update',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['usersList'] })
            queryClient.invalidateQueries({ queryKey: ['userDetail', data.ID] })
          },
        }
      )
    },
  }
}
